// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchDeviceConfigurationPerFleet } from '../../services/DeviceService';
import { DeviceFleetConfiguration, DeviceFleetConfigurationPatch } from '../../types/Devices';

type Result = UseMutationResult<DeviceFleetConfiguration, Error, DeviceFleetConfigurationPatch>;

function usePatchDeviceConfigurationPerFleet(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchDeviceConfigurationPerFleet, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['device-fleet-configuration'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchDeviceConfigurationPerFleet;
